module.exports = {"banks":{"104":"Caixa Econômica Federal","121":"Banco Agibank S.A.","208":"BANCO BTG PACTUAL S.A.","212":"Banco Agibank S.A.","237":"Next Tecnologia e Serviços Digitais","260":"Nubank","336":"Banco C6 S.A.","341":"Banco Itaú S.A.","413":"Banco BV (Before Banco Votorantim)","422":"Banco Safra S.A.","655":"Neon Pagamentos","748":"Banco Cooperativo Sicredi S.A.","001":"Banco do Brasil S.A.","033":"Banco Santander (Brasil) S.A.","041":"Banco do Estado do Rio Grande do Sul S.A. BANRISUL","077":"Banco Inter S.A."}}


//////////////////
// WEBPACK FOOTER
// ./src/views/finance/withdraw-methods/mulix-wd-methods/payretailers-options/BR.json
// module id = 833
// module chunks = 0